import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "block_bj2" }
const _hoisted_4 = { class: "float float2" }
const _hoisted_5 = {
  href: "https://liuyan.www.gov.cn/2024wwzfgzbgtjy/bmdf.html?q=hen",
  target: "_blank"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "float float3" }
const _hoisted_8 = ["src"]

import Banner from './banner/index.vue';
  import ThematicMatters from './thematic-matters/index.vue';
  import Information from './information/index.vue';
  import Message from './message/index.vue';
  import Affairs from './affairs/index.vue';
  import { ref } from 'vue';
  import { useRouter } from "vue-router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const src = ref(require('@/assets/images/float.png'))
  const src2 = ref(require('@/assets/images/float2.jpg'))
  const src3 = ref(require('@/assets/images/float3.png'))
  let float1 = ref(true)
  let float2 = ref(true)
  let float3 = ref(true)

  console.log('process.env:',process.env);
  
  const router = useRouter()

  const toPath = (path:string,type: string = 'router') => {
    if(type != 'router'){
        const url = router.resolve(path);
        console.log('--------',url.href);  // 输出为#/test-url
        // 打开新窗口
        window.open(url.href);
    }else{
        router.push(path)
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top),
    _createVNode(Banner),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ThematicMatters),
        _createVNode(Information),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Message),
          _createVNode(Affairs)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(float2) //@ts-ignore
 ? float2.value = false : float2 = false))
      }, "x"),
      _createElementVNode("div", null, [
        _createElementVNode("a", _hoisted_5, [
          _createElementVNode("img", {
            class: "img_float",
            src: src2.value
          }, null, 8, _hoisted_6)
        ])
      ])
    ], 512), [
      [_vShow, _unref(float2)]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "close",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(float3) //@ts-ignore
 ? float3.value = false : float3 = false))
      }, "x"),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toPath('/simpleOneThingList','open'))),
          target: "_blank"
        }, [
          _createElementVNode("img", {
            class: "img_float",
            src: src3.value
          }, null, 8, _hoisted_8)
        ])
      ])
    ], 512), [
      [_vShow, _unref(float3)]
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})